import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	CanActivateFn,
	CanActivateChildFn,
	createUrlTreeFromSnapshot,
	Router,
} from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const authAutoLoginGaurd: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	return authService.isLoggedIn.pipe(
		take(1),
		map((isLoggedIn) => {
			if (!isLoggedIn) {
				router.navigate(['/signin']);
			}
			return isLoggedIn;
		})
	);
};

export const canActivateAutoChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
	authAutoLoginGaurd(route, state);
